<form *transloco="let t" class="flex flex-col gap-4" [formGroup]="formGroup" (submit)="confirm()">
  @if (encounters$ | async; as encounters) {
    @if (encounters.length > 0) {
      <p>{{ t('Sélectionnez le séjour dans lequel vous souhaitez exporter le rapport du patient.') }}</p>
    }
    <div
      class="flex max-h-[50vh] min-h-[300px] flex-col gap-2 overflow-y-auto"
      data-testid="scroll-viewport"
      scroll-tracker
      [threshold]="{ bottom: 100 }"
      (bottomThreshold)="loadNextPage()">
      @for (encounter of encounters; track encounter.id) {
        <label tuiBlock [attr.data-testid]="encounter.id">
          <input
            formControlName="encounterId"
            tuiRadio
            type="radio"
            [attr.data-testid]="encounter.id + '-input'"
            [value]="encounter.id" />
          @let config = encounterStatusConfig[encounter.status] ?? unknownEncouterStatusConfig;
          <div class="flex w-full items-center gap-2">
            @if (encounter.ufCode !== null || encounter.identifier !== null) {
              <div class="flex flex-1 flex-col items-start gap-1">
                <div class="flex gap-2">
                  @if (encounter.ufCode !== null) {
                    <span data-testid="encounter-uf-code" tuiChip>
                      UF :
                      <strong>{{ encounter.ufCode }}</strong>
                    </span>
                  }
                  @if (encounter.identifier !== null) {
                    <span data-testid="encounter-ehr-identifier" tuiChip>
                      ID :
                      <strong>{{ encounter.identifier }}</strong>
                    </span>
                  }
                </div>
                <ng-container [ngTemplateOutlet]="dateTemplate" />
              </div>
            } @else {
              <ng-container [ngTemplateOutlet]="dateTemplate" />
            }
            <ng-template #dateTemplate>
              <p class="flex-1" data-testid="encounter-date">
                @switch (encounter.status) {
                  @case (EncounterStatus.PLANNED) {
                    {{ t('Séjour à partir du') }}
                    <strong>{{ encounter.fromDate | date }}</strong>
                  }
                  @case (EncounterStatus.IN_PROGRESS) {
                    {{ t('Séjour depuis le') }}
                    <strong>{{ encounter.fromDate | date }}</strong>
                  }
                  @case (EncounterStatus.FINISHED) {
                    {{ t('Séjour du') }}
                    <strong>{{ encounter.fromDate | date }}</strong>
                    {{ t('au') }}
                    <strong>{{ encounter.toDate | date }}</strong>
                  }
                }
              </p>
            </ng-template>
            <span data-testid="encounter-state" tuiBadge [appearance]="config.appearance">
              {{ t(config.label) }}
            </span>
          </div>
        </label>
      }
      @if (encounters.length === 0) {
        <pxc-empty-state
          class="my-auto"
          data-testid="no-encounter-message"
          icon="@tui.search"
          [description]="t('Ce patient n\'a aucun séjour enregistré dans son DPI.')"
          [title]="t('Aucun séjour')" />
      }
    </div>
  } @else {
    <pxc-loader class="my-2" data-testid="loading">
      {{ t('Chargement des séjours du patient ...') }}
    </pxc-loader>
  }

  <div class="flex justify-between gap-2">
    <button appearance="outline" data-testid="cancel" tuiButton type="button" (click)="close()">
      {{ t('Annuler') }}
    </button>
    <button data-testid="confirm" tuiButton type="submit" [disabled]="!formGroup.valid">
      {{ t('Confirmer') }}
    </button>
  </div>
</form>
